export default __webpack_public_path__ + "static/media/marauders-map-v5.0-gallery-09.af7a526f.jpg";